import React, { useState } from "react";
import "./Special_Instructions_Modal.css";
import { Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Blue_Btn from "../common_btn/blue_btn/Blue_Btn";

function Special_Instructions_Modal(props) {
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = (data) => {

    props.setNote(data?.table_no)
    props?.onHide();
    setShowSucsessModal(true);
    // Handle form submission logic here
  };

  return (
    <>
      <section className=" Special_Instructions_Modal modal-holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className=" Special_Instructions_Modal modal-holder"
        >
          <Modal.Header className="common_modal_header">
            <Modal.Title className="note_modal_title">
              Add Delivery Note
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="main_modal_holder">
                <div className="input_div">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="table_no"
                    placeholder="Type your special request here (0 - 200 characters)"
                    {...register("table_no", {
                      required: "This field is required",
                      maxLength: {
                        value: 200,
                        message: "Maximum 200 characters allowed",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.table_no,
                      "is-valid": getValues("table_no") && !errors?.table_no,
                    })}
                  />
                  {errors.table_no && (
                    <p className="text-danger">{errors.table_no.message}</p>
                  )}
                </div>

                <p className="limit-text">Please note that a maximum of 200 words is allowed.</p>

                <div className="btn_holder  ">
                  <Blue_Btn
                    type="sumbit"
                    btn_name="Submit"
                    // onClick={() => {
                    //   props?.onHide();
                    //   setShowSucsessModal(true);
                    // }}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        {/* <Success_Modal
          show={showSuccessModal}
          onHide={() => { setShowSucsessModal(false) }}
          successText="Note Submitted !"
        /> */}
      </section>
    </>
  );
}

export default Special_Instructions_Modal;
